<template>
  <div class="page-footer">
    <p class="footer-text">@ GEA 10th Annual Conference</p>
    <div class="to-top" @click="handleToTop">
      <svg-to-top class="svg"></svg-to-top>
    </div>
  </div>
</template>

<script>
import SvgToTop from '@/components/svg/SvgToTop.vue'
import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'PageFooter',
  components: {
    SvgToTop
  }
})
export default class extends Vue {

  handleToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}
</script>

<style lang="scss">
.page-footer {
  position: absolute;
  bottom: 0px;
  width: 100%;
  z-index: 1000;
  height: 100px;
  background-color: #1C1C1C;
  .footer-text {
    color: #fff;
    font-size: 12px;
    line-height: 100px;
    text-align: center;
  }
  .to-top {
    position: absolute;
    right: 52px;
    top: 24%;
    cursor: pointer;
  }
}
@media screen and (max-width: 576px) {
  .page-footer {
    height: 60px;
    .footer-text {
      line-height: 60px;
    }
    .to-top {
      right: 24px;
      top: 24%;
      .svg {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>